import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import { getDetalleSorteo, getResumenSorteo } from "../../../api/ApiService";


function SorteoDetalle() {
    const [cargando, setCargando] = useState(false);
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [detalleSorteo, setDetalleSorteo] = useState(null);

    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');



    const stateToken = useSelector(state => state.reducerGlobal.token);

    const params = useParams();

    const { id } = params;

    const navigate = useNavigate();







    //==========================================================funcion para enviar encuesta a la api
    const handleDetalleSorteo = () => {
        getResumenSorteo(id, stateToken?.access_token)
            .then(response => {
                console.log("getResumenSorteo", response);
                setCargando(true);

                setDetalleSorteo(response?.data);

            })
            .catch(error => {
                console.log("error-getResumenSorteo", error);
                setCargando(false);
                setDetalleSorteo(null);

                setMensaje("Error al cargar los datos");
                setSeverity('error');
                setOpen(true);
            })
    }

    useEffect(() => {
        if (id) {
            if (stateToken) {
                handleDetalleSorteo();
            }
        } else {
            setTimeout(() => {
                setCargando(true);
            }, 1000);
        }
    }, [id, stateToken]);





    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };

    const handleCancelar = () => {
        window.history.back();
    };

    const handleSeleccionTipoSorteo = (tipo) => {
        // setSeverity('info');
        // setMensaje(`Opcion seleccionada: ${tipo}.`);
        // setOpen(true);

        if (tipo === 'Sorteo de Prueba') {
            navigate(`/app/admin/sorteo/sorteador-cupon/${id}?mode=prueba`);
        } else if (tipo === 'Sorteo Real') {
            navigate(`/app/admin/sorteo/sorteador-cupon/${id}?mode=real`);
        }
    };

    const formatDateTime = (value) => {
        if (!value) {
            return null;
        }

        const normalizedValue = value.includes('T') ? `${value}:00` : value;
        const date = new Date(normalizedValue);

        if (Number.isNaN(date.getTime())) {
            return null;
        }

        return new Intl.DateTimeFormat('es-PY', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        }).format(date);
    };

    const vigenciaDesde = formatDateTime(detalleSorteo?.vigencia_promocion_desde);
    const vigenciaHasta = formatDateTime(detalleSorteo?.vigencia_promocion_hasta);

    const vigenciaPromocion = vigenciaDesde && vigenciaHasta
        ? `${vigenciaDesde} al ${vigenciaHasta}`
        : detalleSorteo?.vigencia_promocion_app_format
        || detalleSorteo?.vigenciaPromocion
        || detalleSorteo?.vigencia
        || "Sin vigencia";

    const totalCupones = detalleSorteo?.cuponesGenerados
        ?? detalleSorteo?.total_cupones
        ?? detalleSorteo?.totalCupones
        ?? 0;

    const totalUsuarios = detalleSorteo?.total_usuarios
        ?? detalleSorteo?.totalUsuarios
        ?? detalleSorteo?.cantidad_usuarios
        ?? 0;







    return (
        <HeaderCustom>
            <div className="min-h-screen bg-[#dfe6ef] p-4 sm:p-6">
                <div className="mx-auto max-w-7xl">
                    <div className="mb-4">
                        <h1 className="text-2xl font-semibold text-[#343a40]">
                            {detalleSorteo?.titulo || "Detalle del sorteo"}
                        </h1>
                    </div>

                    {cargando ? (
                        <div className="overflow-hidden rounded bg-white shadow-sm border border-[#d8dee8]">
                            <div className="min-h-[335px] px-5 py-5 sm:px-8 sm:py-6">
                                <div className="mx-auto max-w-[470px] overflow-hidden rounded border border-[#4d97c7]">
                                    <div className="bg-[#3f8fbd] px-4 py-2.5 text-xl font-semibold text-white">
                                        Detalles del sorteo
                                    </div>

                                    <div className="grid grid-cols-[1.1fr_1.5fr] text-[15px] text-[#333]">
                                        <div className="border-r border-b border-[#e7edf4] px-3 py-4 font-semibold">
                                            Titulo
                                        </div>
                                        <div className="border-b border-[#e7edf4] px-3 py-4">
                                            {detalleSorteo?.titulo || "-"}
                                        </div>

                                        <div className="border-r border-b border-[#e7edf4] px-3 py-4 font-semibold">
                                            Vigencia de la promocion
                                        </div>
                                        <div className="border-b border-[#e7edf4] px-3 py-4">
                                            {vigenciaPromocion}
                                        </div>

                                        <div className="border-r border-b border-[#e7edf4] px-3 py-4 font-semibold">
                                            Total de cupones
                                        </div>
                                        <div className="border-b border-[#e7edf4] px-3 py-4">
                                            {totalCupones}
                                        </div>

                                        <div className="border-r px-3 py-4 font-semibold">
                                            Total de usuarios
                                        </div>
                                        <div className="px-3 py-4">
                                            {totalUsuarios}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-center justify-between border-t border-[#e6ebf2] bg-white px-5 py-4 sm:px-5">
                                <div className="flex items-center gap-1.5">
                                    <button
                                        type="button"
                                        onClick={() => handleSeleccionTipoSorteo('Sorteo de Prueba')}
                                        className="inline-flex items-center bg-[#4296c8] px-4 py-2 text-base font-semibold text-white transition hover:bg-[#3786b5]"
                                    >
                                        Sorteo de Prueba
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => handleSeleccionTipoSorteo('Sorteo Real')}
                                        className="inline-flex items-center bg-[#08a85f] px-4 py-2 text-base font-semibold text-white transition hover:bg-[#079254]"
                                    >
                                        Sorteo Real
                                    </button>
                                </div>

                                <button
                                    type="button"
                                    onClick={handleCancelar}
                                    className="inline-flex items-center bg-[#ec5a46] px-4 py-2 text-base font-semibold text-white transition hover:bg-[#d94a37]"
                                >
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    ) :
                        (
                            <div className="bg-white rounded-xl shadow-md p-8">
                                <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                                <div className="space-y-4">
                                    <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                    <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                    <div className="h-24 bg-gray-200 rounded animate-pulse" />
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default SorteoDetalle;